import { useAddFavorite, useDeleteFavorite, useSomeFavoriteById } from 'src/features/favorite/model/favorite-storage'
import { useCallback } from 'react'

export const useFavoriteApi = (goodId: number) => {
    const isLiked = useSomeFavoriteById(goodId)
    const addFavorite = useAddFavorite()
    const deleteFavorite = useDeleteFavorite()

    const toggle = useCallback(() => {
        if (isLiked) deleteFavorite(goodId)
        else addFavorite(goodId)
    }, [isLiked, deleteFavorite, goodId, addFavorite])

    return { toggle, isLiked }
}
